// extracted by mini-css-extract-plugin
export var container = "_1-0";
export var formArea = "_1-4";
export var formWrapper = "_1-3";
export var fullWidthButton = "_1-5";
export var loadingSpinner = "_1-6";
export var logo = "_1-2";
export var logoLockup = "_1-1";
export var spin = "_1-7";